import { useEffect, useRef, useState } from 'react';
import { Download, Upload } from '@mui/icons-material';
import { Box, Button, Link } from '@mui/material';
import CustomDropdown from 'src/components/CustomDropdown';
import CustomButton from 'src/components/CustomButton';
import { getBulkTypeStatus } from './api';
import useAxios from 'src/hooks/useAxios';
import { BORDER_COLOR, PRIMARY_COLOR } from 'src/constants';
import useUploadFile from './useUploadFile';
import { POSP_BULK_UPLOAD } from './constant';
import SimpleBackdrop from 'src/components/Backdrop';

const UploadComponents = ({ fetchUploadHistoryAfterUploadFile }) => {
  const [bulkUploadStatusType, setBulkUploadStatusType] = useState<any>([]);
  const [selectedUploadStatus, setSelectedUploadStatus] = useState('');
  const inputRef: any = useRef(null);
  const [uploadFile, uploadPayrollFile] = useUploadFile();
  const [showLoader, setShowLoader] = useState(false);

  const axiosInstance = useAxios();

  const onChangeSelectedUploadStatus = (value) => {
    setSelectedUploadStatus(value);
  };

  const createUploadDropdownData = (data) => {
    const dropdownData = data
      .filter((elt: any) => {
        if (elt?.bulkUploadType !== POSP_BULK_UPLOAD) {
          return elt;
        }
      })
      .map((elt) => {
        return {
          label: elt?.displayName,
          value: elt?.bulkUploadType
        };
      });
    return dropdownData;
  };

  const fetchUploadStatusList = async () => {
    const response = await getBulkTypeStatus(axiosInstance);
    if (response?.data?.responseDTOList?.length) {
      const defaultValue =
        response?.data?.responseDTOList[0]?.bulkUploadType || '';
      onChangeSelectedUploadStatus(defaultValue);
      setBulkUploadStatusType(response?.data?.responseDTOList);
    }
  };

  useEffect(() => {
    fetchUploadStatusList();
  }, []);

  const getTemplateLink = () => {
    const selectedTemplateLink = bulkUploadStatusType.filter(
      (elt) => elt.bulkUploadType === selectedUploadStatus
    );
    return selectedTemplateLink.length
      ? selectedTemplateLink[0].bulkUploadTemplateURI
      : '';
  };

  const onChange = (event) => {
    const file: File = event.target.files[0];
    if (selectedUploadStatus == 'BULK_UPLOAD_PARTNER_PAYROLL_DATA') {
      uploadPayrollFile(file, setShowLoader);
    } else {
      uploadFile(file, selectedUploadStatus, fetchUploadHistoryAfterUploadFile);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        boxShadow: '2px 2px 2px 2px #0000001a',
        mb: 4,
        padding: '20px 10px',
        width: '100%'
      }}>
      <Box sx={{ width: '40%' }}>
        <CustomDropdown
          options={createUploadDropdownData(bulkUploadStatusType)}
          value={selectedUploadStatus}
          onChange={onChangeSelectedUploadStatus}
          label="Upload Type"
          width="90%"
          showDefaultOption={false}
        />
      </Box>
      <input
        type={'file'}
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={onChange}
        accept={selectedUploadStatus === 'BULK_UPLOAD_PARTNER_PAYROLL_DATA' ? '.csv' : '.xlsx'}
      />
      <Button
        color="primary"
        size="medium"
        sx={{
          textTransform: 'capitalize',
          color: PRIMARY_COLOR,
          border: `1px solid ${BORDER_COLOR}`,
          borderRadius: '10px',
          ':hover': {
            background: '#f7f3ff',
            border: `1px solid ${BORDER_COLOR}`
          }
        }}
        variant="outlined"
        startIcon={<Upload />}
        onClick={() => inputRef.current.click()}>
        Upload File
      </Button>
      <Link
        sx={{ marginLeft: 'auto' }}
        href={getTemplateLink()}
        target={'_blank'}
        underline="none">
        <CustomButton
          title="Export Template"
          buttonType="primary"
          variant="contained"
          startIcon={<Download />}
        />
      </Link>
      {showLoader && <SimpleBackdrop open={showLoader} />}
    </Box>
  );
};

export default UploadComponents;
